import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ModelKpiBreakdown } from "../types";

export const useModelKpiBreakdown = (model_id: number) => {
  return useQuery({
    queryKey: ["model", "charts", "kpi_breakdown", model_id],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/charts/kpi_breakdown`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelKpiBreakdown[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
